// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ConfirmTradesStepV2QueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ConfirmTradesStepV2Query = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Region', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Market', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Community', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Subdivision', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Lot', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Structure', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Unit', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
   };

export type ConfirmTradesStepV2_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Region_Fragment = { __typename?: 'Region', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Market_Fragment = { __typename?: 'Market', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Community_Fragment = { __typename?: 'Community', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Lot_Fragment = { __typename?: 'Lot', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Structure_Fragment = { __typename?: 'Structure', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Unit_Fragment = { __typename?: 'Unit', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_ProjectFragment =
  | ConfirmTradesStepV2_Project_StandaloneProject_Fragment
  | ConfirmTradesStepV2_Project_Region_Fragment
  | ConfirmTradesStepV2_Project_Market_Fragment
  | ConfirmTradesStepV2_Project_Community_Fragment
  | ConfirmTradesStepV2_Project_Subdivision_Fragment
  | ConfirmTradesStepV2_Project_Lot_Fragment
  | ConfirmTradesStepV2_Project_Structure_Fragment
  | ConfirmTradesStepV2_Project_Unit_Fragment
;

export const ConfirmTradesStepV2_ProjectFragmentDoc = gql`
    fragment ConfirmTradesStepV2_Project on Project {
  id
  readyPlanConfig {
    id
    readyPlan {
      ...DisplayNamed
    }
  }
}
    ${DisplayNamedFragmentDoc}`;
export const ConfirmTradesStepV2Document = gql`
    query ConfirmTradesStepV2($id: ID!) {
  project(id: $id) {
    ...ConfirmTradesStepV2_Project
  }
}
    ${ConfirmTradesStepV2_ProjectFragmentDoc}`;

/**
 * __useConfirmTradesStepV2Query__
 *
 * To run a query within a React component, call `useConfirmTradesStepV2Query` and pass it any options that fit your needs.
 * When your component renders, `useConfirmTradesStepV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmTradesStepV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmTradesStepV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables> & ({ variables: ConfirmTradesStepV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>(ConfirmTradesStepV2Document, options);
      }
export function useConfirmTradesStepV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>(ConfirmTradesStepV2Document, options);
        }
// @ts-ignore
export function useConfirmTradesStepV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>;
export function useConfirmTradesStepV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfirmTradesStepV2Query | undefined, ConfirmTradesStepV2QueryVariables>;
export function useConfirmTradesStepV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>(ConfirmTradesStepV2Document, options);
        }
export type ConfirmTradesStepV2QueryHookResult = ReturnType<typeof useConfirmTradesStepV2Query>;
export type ConfirmTradesStepV2LazyQueryHookResult = ReturnType<typeof useConfirmTradesStepV2LazyQuery>;
export type ConfirmTradesStepV2SuspenseQueryHookResult = ReturnType<typeof useConfirmTradesStepV2SuspenseQuery>;
export type ConfirmTradesStepV2QueryResult = Apollo.QueryResult<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>;